import { loadPdfDocumentBlankPassword } from "./loadPdfDocument";

export const getEncryptedPdfPageCount = async (file: File): Promise<number> => {
  const pdfDocPageCount = await loadPdfDocumentBlankPassword<number>(file, { returnPageCount: true });
  return pdfDocPageCount;
};
